import dependent from '../components/dependent'

export default {
  dependent
}



// WEBPACK FOOTER //
// ./src/app/settings/dependents/index/resources/components.js